module.exports = __webpack_public_path__ + "img/map.ce40af5f.png";